import React, { useState } from 'react';
import { useUser } from '../../context/UserContext';
import { CheckIcon, HeartIcon, BrainIcon, SunIcon, LeafIcon, ShieldIcon, SmileIcon } from 'lucide-react';
interface GoalsPromptProps {
  onContinue: () => void;
}
const GoalsPrompt: React.FC<GoalsPromptProps> = ({
  onContinue
}) => {
  const {
    updateUserData
  } = useUser();
  const [selectedGoal, setSelectedGoal] = useState<string>('');
  const goals = [{
    id: 'reduce-stress',
    title: 'Reduce stress',
    description: 'Find more calm and peace in your daily life',
    icon: LeafIcon,
    color: 'bg-blue-100',
    textColor: 'text-blue-800',
    borderColor: 'border-blue-300'
  }, {
    id: 'build-confidence',
    title: 'Build confidence',
    description: 'Develop stronger self-belief and personal power',
    icon: ShieldIcon,
    color: 'bg-purple-100',
    textColor: 'text-purple-800',
    borderColor: 'border-purple-300'
  }, {
    id: 'improve-relationships',
    title: 'Improve relationships',
    description: 'Create deeper connections with others',
    icon: HeartIcon,
    color: 'bg-pink-100',
    textColor: 'text-pink-800',
    borderColor: 'border-pink-300'
  }, {
    id: 'find-clarity',
    title: 'Find clarity',
    description: 'Discover your purpose and direction',
    icon: SunIcon,
    color: 'bg-yellow-100',
    textColor: 'text-yellow-800',
    borderColor: 'border-yellow-300'
  }, {
    id: 'enhance-wellbeing',
    title: 'Enhance well-being',
    description: 'Improve your overall health and vitality',
    icon: SmileIcon,
    color: 'bg-green-100',
    textColor: 'text-green-800',
    borderColor: 'border-green-300'
  }, {
    id: 'personal-growth',
    title: 'Personal growth',
    description: 'Expand your capabilities and potential',
    icon: BrainIcon,
    color: 'bg-indigo-100',
    textColor: 'text-indigo-800',
    borderColor: 'border-indigo-300'
  }];
  const handleSelectGoal = (goal: string) => {
    setSelectedGoal(goal);
  };
  const handleSubmit = () => {
    if (selectedGoal) {
      // Get the title of the selected goal
      const goalTitle = goals.find(g => g.id === selectedGoal)?.title || selectedGoal;
      updateUserData({
        goal: goalTitle
      });
      onContinue();
    }
  };
  return <div data-id="element-327">
      <h2 className="text-2xl font-bold mb-6 text-center text-green-700" data-id="element-328">
        Your Primary Goal
      </h2>
      <p className="text-gray-600 mb-6" data-id="element-329">
        What would you most like to achieve through your journey with
        SevenAfter? Select the goal that resonates most with you right now.
      </p>
      <div className="grid grid-cols-2 gap-3 mb-6" data-id="element-330">
        {goals.map(goal => {
        const Icon = goal.icon;
        return <button key={goal.id} onClick={() => handleSelectGoal(goal.id)} className={`
                flex flex-col items-center p-4 rounded-lg text-center transition-all
                ${goal.color} ${goal.textColor}
                ${selectedGoal === goal.id ? `ring-2 ring-green-500 ${goal.borderColor}` : 'border border-transparent hover:border-gray-200'}
              `} data-id="element-331">
              <div className="relative mb-2" data-id="element-332">
                <Icon size={28} data-id="element-333" />
                {selectedGoal === goal.id && <div className="absolute -top-1 -right-1 bg-green-500 rounded-full w-4 h-4 flex items-center justify-center" data-id="element-334">
                    <CheckIcon size={10} className="text-white" data-id="element-335" />
                  </div>}
              </div>
              <h3 className="font-medium text-sm mb-1" data-id="element-336">{goal.title}</h3>
              <p className="text-xs opacity-80" data-id="element-337">{goal.description}</p>
            </button>;
      })}
      </div>
      <button onClick={handleSubmit} disabled={!selectedGoal} className={`
          bg-green-600 text-white py-3 px-6 rounded-lg shadow-md hover:bg-green-700 transition-colors w-full font-medium
          ${!selectedGoal ? 'opacity-50 cursor-not-allowed' : ''}
        `} data-id="element-338">
        Continue
      </button>
    </div>;
};
export default GoalsPrompt;